import React from "react";
import { StatusAlert } from "@/components/auth";
import { withAppBase } from "@/lib/appPaths";
import { LOGIN_STATES } from "@/hooks/useLogin.types";
import type { LoginErrorAlertProps } from "./LoginErrorAlert.types";

export const LoginErrorAlert: React.FC<LoginErrorAlertProps> = ({
  state,
  triesLeft,
}) => {
  switch (state) {
    case LOGIN_STATES.INVALID_CREDENTIALS:
      return (
        <StatusAlert
          variant="error"
          title="Sign in failed"
          message="Incorrect email or password. Please check your credentials and try again."
        />
      );
    case LOGIN_STATES.ACCOUNT_BLOCKED:
      return (
        <StatusAlert
          variant="error"
          title="Account Blocked"
          message="Your admin account has been blocked. Contact support for assistance."
          action={
            <a
              href="mailto:support@smartstore.com"
              className="text-sm font-medium text-rose-700 dark:text-rose-300 hover:underline"
            >
              Contact Support
            </a>
          }
        />
      );
    case LOGIN_STATES.ACCOUNT_DISABLED:
      return (
        <StatusAlert
          variant="warning"
          title="Account Disabled"
          message="Your account is currently disabled. Please contact your administrator to re-enable access."
        />
      );
    case LOGIN_STATES.NOT_ACTIVATED:
      return (
        <StatusAlert
          variant="info"
          title="Account Not Activated"
          message="Your account is not activated yet. Please accept your invitation first to complete registration."
          action={
            <a
              href={withAppBase("/invite/accept")}
              className="text-sm font-medium text-blue-700 dark:text-blue-300 hover:underline"
            >
              Accept Invitation
            </a>
          }
        />
      );
    case LOGIN_STATES.WRONG_CODE:
      return (
        <StatusAlert
          variant="error"
          title="Wrong code"
          message={
            triesLeft === undefined
              ? "Wrong code. Please try again."
              : `Wrong code. ${triesLeft} ${triesLeft === 1 ? "try" : "tries"} left.`
          }
        />
      );
    case LOGIN_STATES.TOO_MANY_TRIES:
      return (
        <StatusAlert
          variant="error"
          title="Too many tries"
          message="Too many tries. Please log in again."
        />
      );
    case LOGIN_STATES.TICKET_EXPIRED:
      return (
        <StatusAlert
          variant="warning"
          title="Code expired"
          message="Code expired. Please log in again."
        />
      );
    case LOGIN_STATES.CODE_SEND_FAILED:
      return (
        <StatusAlert
          variant="error"
          title="Code not sent"
          message="We could not send your code. Try again in a minute."
        />
      );
    case LOGIN_STATES.SOMETHING_WRONG:
      return (
        <StatusAlert
          variant="error"
          message="Something went wrong. Please try again."
        />
      );
    default:
      return null;
  }
};
